import * as React from "react";
import { ObjectFieldRenderer } from "../Interfaces/objectFieldRenderer";
import { ArrayFieldRenderer } from "../Interfaces/arrayFieldRenderer";
import { DefaultFieldRenderer } from "../Interfaces/defaultFieldRenderer";
import { ReadItemFieldRenderer } from "../Interfaces/readItemFieldRenderer";

interface IFieldRenderProps {
  default: DefaultFieldRenderer;
  array: ArrayFieldRenderer;
  object: ObjectFieldRenderer;
  readItem: ReadItemFieldRenderer;
}

interface IFieldRenderContextProviderProps {
  value: IFieldRenderProps;
  children: React.ReactNode;
}

export const FieldRenderContext = React.createContext<IFieldRenderProps | null>(null);

export const useFieldRenderContext = () => React.useContext(FieldRenderContext);

export const FieldRenderContextProvider = (props: IFieldRenderContextProviderProps) => {
  return <FieldRenderContext.Provider value={props.value}>{props.children}</FieldRenderContext.Provider>;
};
